<div
  class="alert"
  [innerText]="message"
  [ngClass]="{
    'alert-err-warn': type === 'error' || type === 'warning',
    'alert-success-info': type === 'success' || type === 'info'
  }"
></div>
